import React from "react";
import PatioManagerDocaFormPageContainer from "./PatioManagerDocaFormPageContainer";

export class PatioManagerDocaFormPage extends React.Component {
  render() {
    return <PatioManagerDocaFormPageContainer {...this.props} />;
  }
}
